/** Notificação nativa do navegador (estilo Slack) para mensagem nova no Board Chat. */
import { requestBoardChatOpen } from './boardChatLayout';

const BODY_MAX = 140;

let permissionBound = false;

function isSupported() {
  return typeof window !== 'undefined' && 'Notification' in window;
}

function requestPermission() {
  if (!isSupported() || Notification.permission !== 'default') return;
  try {
    const p = Notification.requestPermission();
    if (p?.catch) p.catch(() => {});
  } catch {
    /* navegadores antigos / bloqueado */
  }
}

/** Pede permissão no primeiro gesto do usuário (Firefox/Safari exigem gesto). */
export function armBoardChatDesktopNotify() {
  if (permissionBound || !isSupported() || typeof document === 'undefined') return;
  if (Notification.permission !== 'default') return;
  permissionBound = true;
  const onGesture = () => {
    document.removeEventListener('pointerdown', onGesture);
    document.removeEventListener('keydown', onGesture);
    requestPermission();
  };
  document.addEventListener('pointerdown', onGesture, { passive: true });
  document.addEventListener('keydown', onGesture);
}

function isAppInForeground() {
  if (typeof document === 'undefined') return true;
  return document.visibilityState === 'visible' && document.hasFocus();
}

function truncate(text) {
  const s = String(text || '').replace(/\s+/g, ' ').trim();
  return s.length > BODY_MAX ? `${s.slice(0, BODY_MAX - 1)}…` : s;
}

/**
 * Exibe notificação do sistema quando a aba está oculta, minimizada ou sem foco.
 * @param {{ conversationId?: number|null, senderName?: string, content?: string, hasAttachment?: boolean }} msg
 */
export function showBoardChatDesktopNotification(msg) {
  if (!isSupported()) return;
  if (Notification.permission === 'default') {
    requestPermission();
    return;
  }
  if (Notification.permission !== 'granted' || isAppInForeground()) return;

  const title = msg?.senderName ? `${msg.senderName} · Chat` : 'Nova mensagem no Chat';
  const body = truncate(msg?.content) || (msg?.hasAttachment ? 'Enviou um anexo' : 'Nova mensagem');
  const tag = msg?.conversationId ? `bch-conv-${msg.conversationId}` : 'bch-message';

  try {
    const n = new Notification(title, {
      body,
      tag,
      renotify: true,
      icon: `${process.env.PUBLIC_URL || ''}/logo192.png`,
    });
    n.onclick = () => {
      try {
        window.focus();
      } catch {
        /* ignore */
      }
      requestBoardChatOpen();
      n.close();
    };
  } catch {
    /* Android Chrome exige ServiceWorker; ignora */
  }
}
